import { create } from 'zustand';
import type { TypeAgenda } from '@/lib/types';

type UiState = {
  newRdvModalOpen: boolean;
  newRdvDefaultType: TypeAgenda;
  openNewRdvModal: (type?: TypeAgenda) => void;
  closeNewRdvModal: () => void;
};

export const useUiStore = create<UiState>((set) => ({
  newRdvModalOpen: false,
  newRdvDefaultType: 'rapide',
  openNewRdvModal: (type = 'rapide') => set({ newRdvModalOpen: true, newRdvDefaultType: type }),
  closeNewRdvModal: () => set({ newRdvModalOpen: false }),
}));
